.sc-razorpay-button-container {
  display: block;
}
